module.exports = __webpack_public_path__ + "static/media/pastevent3.3ab4a6d4.jpg";